import { ILocation } from '@models/interfaces/ILocation';
import { DefaultLocationFormatter } from '../default-location-formatter';

export class CvpLocationFormatter extends DefaultLocationFormatter {
  format(location: ILocation): string[] {
    const line1: string = super.format(location)[0];

    const jsonMiscData = this.parseMiscData(location.LocationMiscData);

    const line2: string = this.renderAccessPoint(location, jsonMiscData['Entree'], 'Mobile.Highway.Entrance');
    const line3: string = this.renderAccessPoint(location, jsonMiscData['Sortie'], 'Mobile.Highway.Exit');

    return [line1, line2, line3].filter(s => s);
  }

  private renderAccessPoint(location: ILocation, jsonMiscData, prefixKey: string): string {
    const lineFields: string = jsonMiscData
      ? [this.renderFields(['SFULLTEXT', 'REFNODES_SNAME'], location, jsonMiscData), this.getKmPoint(jsonMiscData)]
          .filter(s => s)
          .join(', ')
      : '';
    return lineFields ? `${this.translate.instant(prefixKey)}: ${lineFields}` : '';
  }
}
